import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../client/stores";
import { Environment } from "../../../client/stores";
import * as Webapi from "../generated/webapi.g";
import { CatalogKindTypes, generateCatalogUrl } from "../lib/catalog";
import "./IHRPlayerBar.style.scss";

export interface IHRPlayerBarProps {
    store?: Store;
}

const getWidgetIframeUrl = (
    env: Environment,
    override: Webapi.CatalogPointerRef,
    theme = "light",
    campId: string,
    sc: string,
    pName: string,
) => {
    const { id, kind } = override;
    return `${generateCatalogUrl(env, {
        id,
        kind: CatalogKindTypes[kind],
        embed: true,
        query: {
            sc,
            campid: campId,
            pname: pName,
            theme,
        },
    })}`;
};

export const IHRPlayerBar = inject("store")(({ store }: IHRPlayerBarProps) => {
    if (!store) {
        return null;
    }

    const designConfig = store?.site.config.sections?.design;
    const campid = "b";
    const sc = "inferno";
    const pname = store?.site.index.slug.toUpperCase() || "";

    if (
        !designConfig ||
        !designConfig.ihr_embed_player_bar_switch ||
        !designConfig.ihr_embed_player_bar_stream_override ||
        !designConfig.ihr_embed_player_bar_stream_theme
    ) {
        return null;
    }

    const url = getWidgetIframeUrl(
        store.env,
        designConfig.ihr_embed_player_bar_stream_override,
        designConfig.ihr_embed_player_bar_stream_theme,
        campid,
        sc,
        pname,
    );

    return (
        <React.Fragment>
            <div className="ihr-player-bar">
                <div className="ihr-player-bar-content">
                    <iframe
                        title="Listen on iHeartRadio"
                        id="ihr-player-bar-frame"
                        allow="autoplay"
                        src={url}
                        scrolling="no"
                        frameBorder={0}
                    />
                </div>
            </div>
        </React.Fragment>
    );
});
export default IHRPlayerBar;
